import { apiService, type UsageEventInput } from '@/services/api';
import { captureTrafficSource, formatTrafficSourceForEvent } from '@/utils/trafficSource';

const DEFAULT_DEDUPE_MS = 4000;

export interface TrackUsageEventOptions {
  /** Ignorer si navigation arrière (POP). */
  skipOnPop?: boolean;
  navigationType?: 'POP' | 'PUSH' | 'REPLACE';
  dedupeMs?: number;
  /** Contexte additionnel pour la clé de dédoublonnage (ex. id match). */
  dedupeContext?: string;
  /** Joindre la source de trafic capturée en session. */
  withSource?: boolean;
}

function buildDedupeKey(type: string, tifosi: string, context: string): string {
  return `gopaas_evt:${type}:${tifosi}:${context}`;
}

/**
 * Enregistre un événement `tifosi_event` (best-effort, dédoublonnage sessionStorage).
 */
export function trackUsageEvent(input: UsageEventInput, options: TrackUsageEventOptions = {}): void {
  const tifosi = String(input.tifosi || '').trim();
  if (!tifosi) return;

  if (options.skipOnPop !== false && options.navigationType === 'POP') return;

  const dedupeMs = options.dedupeMs ?? DEFAULT_DEDUPE_MS;
  const context = options.dedupeContext ?? input.match_football ?? input.club ?? input.type;
  const dedupeKey = buildDedupeKey(input.type, tifosi, String(context));

  try {
    const prev = sessionStorage.getItem(dedupeKey);
    if (prev) {
      const ts = Number(prev);
      if (Number.isFinite(ts) && Date.now() - ts < dedupeMs) return;
    }
    sessionStorage.setItem(dedupeKey, String(Date.now()));
  } catch {
    /* sessionStorage indisponible */
  }

  const payload: UsageEventInput = { ...input, tifosi };
  if (options.withSource && !payload.source) {
    captureTrafficSource();
    payload.source = formatTrafficSourceForEvent();
  }

  void apiService.createUsageEvent(payload).catch(() => {
    try {
      sessionStorage.removeItem(dedupeKey);
    } catch {
      /* ignore */
    }
  });
}
